// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uZ2w","top":"styles_top__1REXb","left":"styles_left__XTKhW","description":"styles_description__vddxa"};